import { useQuery } from '@tanstack/react-query';
import { VacationOverviewService } from '../../services/vacationOverviewService';
import type { VacationOverviewDocument } from '../../models/vacationOverview.types';

export function useVacationOverviewQuery() {
	return useQuery<VacationOverviewDocument[]>({
		queryKey: ['vacationOverview'],
		queryFn: () => VacationOverviewService.getAllOverviews(),
		staleTime: 5 * 60 * 1000,
	});
}

export function useVacationOverviewData() {
	const docs = useVacationOverviewQuery();

	const loadedAt = docs.dataUpdatedAt ? new Date(docs.dataUpdatedAt) : null;

	const refresh = () => {
		docs.refetch();
	};

	return {
		docs: docs.data ?? [],
		loadedAt,
		isFetching: docs.isFetching,
		refresh,
		isLoading: docs.isLoading,
		error: docs.data ? null : docs.error,
	};
}
